'use client'
import * as React from 'react'
import dynamic from 'next/dynamic'
import { useTranslations } from 'next-intl'

import { ErrorBoundaryWrapper } from '../error-boundary'

/**
 * We are using dynamic import to load the modal component only when the user clicks on the report button.
 * It creates a separate chunk for the modal component and loads it only when required.
 */
const Modal = dynamic(() => import('./modal').then(module => module.ReportModal), {
  ssr: false,
  loading: () => null,
})

export function ReportButton({ productTitle }: { productTitle: string }) {
  const t = useTranslations('prod.product_description_page.report')
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  return (
    <>
      <button
        className="text-[#0A5EA8] underline hover:no-underline"
        onClick={() => {
          setIsModalOpen(true)
        }}
      >
        {t('button')}
      </button>
      <ErrorBoundaryWrapper>
        {isModalOpen ? (
          <Modal
            productTitle={productTitle}
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false)
            }}
          />
        ) : null}
      </ErrorBoundaryWrapper>
    </>
  )
}
